import Modal from "react-modal";
import { handleInput } from "../../../classes/functions";
import "./index.css";

export default function ModalAuxiliaresData({showModalAuxiliariesData, headerAuxiliaresDatas, typeItens, itens, view, origin, currentItem}){
    const isIntegrated = (origin !== "" && origin !== "002");

    function changeAuxiliaresDatasValue(itemID, stateName, value){
        return itens?.setState(itens?.state?.map((item) => {
          if(item.id === itemID){
            item.dados_aux = {};
            item.dados_aux[stateName] = value;
          }
    
          return item;
        }));
    }

    function cleanAuxiliaresDataInputsAndCloseModal(){
        if(!isIntegrated){
          headerAuxiliaresDatas?.setState({processo: "", servico: "", lote: "", container: "", consolidado: ""});
          currentItem?.setState(0);
        }
    
        showModalAuxiliariesData?.setState(false);
    }

    function confirmAuxiliaresDataValues(){
        itens?.setState(itens?.state);
    
        currentItem?.setState(0);
        showModalAuxiliariesData?.setState(false);
    }

    return (
        <Modal
            isOpen={showModalAuxiliariesData?.state}
            onRequestClose={() => showModalAuxiliariesData?.setState(false)}
            className="modal-auxiliaries-data"
            overlayClassName="modal-overlay"
        >
            <form className="containerGroupData" style={{padding: "2rem"}}>
            <div>
                <h2>Dados Adicionais do Documento de Entrada</h2>
                <hr></hr>
                <div className="divGroup">
                <div className="formDiv">
                    <label>Processo</label><br />
                    <input type="text" placeholder="Processo" name="processo" value={headerAuxiliaresDatas?.state?.processo} onChange={(e) => handleInput(headerAuxiliaresDatas?.setState, e)} disabled={(view || origin !== '' && origin !== '002')} />
                </div>
                <div className="formDiv">
                    <label>Serviço</label><br />
                    <input type="text" placeholder="Serviço" name="servico" value={headerAuxiliaresDatas?.state?.servico} onChange={(e) => handleInput(headerAuxiliaresDatas?.setState, e)} disabled={(view || origin !== '' && origin !== '002')} />
                </div>
                <div className="formDiv">
                    <label>Lote</label><br />
                    <input type="text" placeholder="Lote" name="lote" value={headerAuxiliaresDatas?.state?.lote} onChange={(e) => handleInput(headerAuxiliaresDatas?.setState, e)} disabled={(view || origin !== '' && origin !== '002')} />
                </div>
                <div className="formDiv">
                    <label>Container</label><br />
                    <input type="text" placeholder="Container" name="container" value={headerAuxiliaresDatas?.state?.container} onChange={(e) => handleInput(headerAuxiliaresDatas?.setState, e)} disabled={(view || origin !== '' && origin !== '002')} />
                </div>
                <div className="formDiv">
                    <label>Consolidado</label><br />
                    <input type="text" placeholder="Consolidado" name="consolidado" value={headerAuxiliaresDatas?.state?.consolidado} onChange={(e) => handleInput(headerAuxiliaresDatas?.setState, e)} disabled={(view || origin !== '' && origin !== '002')} />
                </div>
                </div>
            </div>
            <div>
                <h2>Dados Auxiliares dos Produtos</h2>
                {itens?.state?.map((item, index) => {
                    return (
                        <div className="divGroup" key={index}>
                            <div className="formDiv" style={{width: "250%"}}>
                                <label>Produto</label>
                                <input type="text" placeholder="Produto" value={typeItens === "entrada-documentos" ? `${item?.id_produto} - ${item?.descricao}` : `${item.produto_item}`} />
                            </div>
                            <div className="formDiv">
                                <label>Doc. aduaneiro</label>
                                <input type="text" placeholder="Doc. aduaneiro" name="doc_aduaneiro" value={item?.dados_aux?.doc_aduaneiro} onChange={(e) => changeAuxiliaresDatasValue(item?.id, "doc_aduaneiro", e.target.value)} disabled={(view || origin !== '' && origin !== '002')} />
                            </div>
                            <div className="formDiv">
                                <label>Peso Declarado</label>
                                <input type="text" placeholder="Peso Declarado" name="peso_declarado" value={item?.dados_aux?.peso_declarado} onChange={(e) => changeAuxiliaresDatasValue(item?.id, "doc_aduaneiro", e.target.value)} disabled={(view || origin !== '' && origin !== '002')} />
                            </div>
                            <div className="formDiv">
                                <label>Peso Aferido</label>
                                <input type="text" placeholder="Peso Aferido" name="peso_aferido" value={item?.dados_aux?.peso_aferido} onChange={(e) => changeAuxiliaresDatasValue(item?.id, "doc_aduaneiro", e.target.value)} disabled={(view || origin !== '' && origin !== '002')} />
                            </div>
                            <div className="formDiv">
                                <label>Embalagem</label>
                                <input type="text" placeholder="Embalagem" name="doc_aduaneiro" value={item?.dados_aux?.embalagem} onChange={(e) => changeAuxiliaresDatasValue(item?.id, "doc_aduaneiro", e.target.value)} disabled={(view || origin !== '' && origin !== '002')} />
                            </div>
                            <div className="formDiv">
                                <label>Doc. Fiscal</label>
                                <input type="text" placeholder="Doc. Fiscal" name="doc_fiscal" value={item?.dados_aux?.doc_fiscal} onChange={(e) => changeAuxiliaresDatasValue(item?.id, "doc_aduaneiro", e.target.value)} disabled={(view || origin !== '' && origin !== '002')} />
                            </div>
                        </div>
                    )
                })}
            </div>
            <br />
            <div className="modal-buttons">
                {(!view) || (origin === '002') && <button type="button" className="buttonSubmit" onClick={confirmAuxiliaresDataValues}>Confirmar</button>}
                <button type="button" className="buttonCancel" onClick={cleanAuxiliaresDataInputsAndCloseModal}>Cancelar</button>
            </div>
            </form>
        </Modal>
    )
}